
import Vue from 'vue';
import ShippingLabels from './ShippingLabels.vue';

export default Vue.extend({
	name: 'ShippingLabelDialog',
	components: {
		ShippingLabels
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		orderId: {
			type: Number,
			required: true
		},
		pickTicketId: {
			type: Number,
			required: false
		}
	},
	data() {
		return {
			dialog: this.value
		};
	},
	watch: {
		value(val) {
			this.dialog = val;
		},
		dialog(val) {
			this.$emit('input', val);
		}
	},
	methods: {
		handleClose() {
			this.dialog = false;
			this.$emit('close');
		},
		
		onLabelCreated(labelData: any) {
			// Extract tracking number from the label data (handle both camelCase and snake_case)
			const trackingNumber = labelData.label?.trackingNumber || 
								  labelData.label?.tracking_number || 
								  labelData.trackingNumber || 
								  labelData.tracking_number;
			
			// Emit event with tracking number and pick ticket ID
			this.$emit('label-created', {
				pickTicketId: this.pickTicketId,
				trackingNumber: trackingNumber,
				labelData: labelData
			});
			
			// Close dialog after successful label creation
			this.handleClose();
		},
		
		onError(error: any) {
			this.$emit('error', error);
		},
		
		onSuccess(message: string) {
			this.$emit('success', message);
		}
	}
});
